/**
 * The form `Conversation.tagsNormalized` holds, and what the tag filter matches.
 *
 * A chip's tag is a `CandidateTag.value`, which the catalog already stores
 * composed, trimmed and with whitespace runs collapsed. Lowercasing is the only
 * step left, so this equals the `valueNormalized` beside it rather than
 * reimplementing how one is derived from the other.
 *
 * Matching `tags` instead splits two files heading a column `VISA` and `visa`,
 * which the catalog holds as one tag, so the filter returns one file's
 * candidates and hides the other with nothing raising an error.
 */
export const canonicalTag = (tag: string): string => tag.toLowerCase();
